import React, { useState, useEffect } from "react";
import "../styles/tableStyles.css";

function Standings() {
    const [standingsData, setStandingsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch("/api/standingsData.json")
            .then(response => response.json())
            .then(data => {
                setStandingsData(data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setError("Unable to load standings.");
                setLoading(false);
            });
    }, []);

    if (loading) return <div>Loading Standings...</div>;
    if (error) return <div>{error}</div>;

    return (
        <div className="table-container">
            <div className="standings-table-wrapper">
                <table className="standings-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Team</th>
                            <th>MP</th>
                            <th>W</th>
                            <th>D</th>
                            <th>L</th>
                            <th>GF</th>
                            <th>GA</th>
                            <th>GD</th>
                            <th>Pts</th>
                        </tr>
                    </thead>
                    <tbody>
                        {standingsData.map((team, index) => (
                            <tr key={index}>
                                <td>{team.position}</td>
                                <td>{team.team}</td>
                                <td>{team.played}</td>
                                <td>{team.won}</td>
                                <td>{team.drawn}</td>
                                <td>{team.lost}</td>
                                <td>{team.goalsFor}</td>
                                <td>{team.goalsAgainst}</td>
                                <td>{team.goalDiff}</td>
                                <td>{team.points}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Standings;
